<mat-card>
  <mat-card-header>
    <mat-card-title>SKILLS & EXPERIENCE</mat-card-title>
    <button class="usa-button usa-button--secondary" (click)="edit()" style="min-width: 70px;" *ngIf="editable()"
      aria-label="Edit Skills">
      <fa-icon [icon]="faEdit" style="color: #216E1F;"></fa-icon>&nbsp;Edit
    </button>
  </mat-card-header>
  <mat-card-content>

    <div class="data-column">
      <div class="data-div">
        <p class="data-title">BAER IQCS Qualifications</p>
        <div class="available-list">
          <mat-chip *ngIf="user().BAS">BAER Specialist - Fireline (BAS)</mat-chip>
          <mat-chip *ngIf="user().BADO">BAER Documentation Specialist - Office (BADO)</mat-chip>
          <mat-chip *ngIf="user().BAEL">BAER Team Leader (BAEL)</mat-chip>
          <p *ngIf="!user().BAS && !user().BADO && !user().BAEL">--</p>
        </div>
      </div>
      <div class="skill-list">
        <div class="data-title" style="padding-top: 0px;">BAER Skills/Roles</div>
        <div class="data-title" style="padding-top: 0px;">Experience level <div class="data-subtitle"
            style="flex: 100%; padding-left: 0px;">(# of assignments)</div>
        </div>
        @for (skill of skills_list; track skill) {
        <div>{{skill.text | skills}}</div>
        <div *ngIf="skill.experience">{{skill.experience}}</div>
        <div *ngIf="!skill.experience">--</div>
        }
      </div>
    </div>
    <div class="data-column">
      <div class="data-div">
        <div class="data-title">
          <div style="max-width: 300px;">Experience with large or complex fires </div>
          <div class="data-subtitle">(150,000+ acres)</div>
        </div>
        <p class="data-info" *ngIf="user().large_fire_exp != null">{{user().large_fire_exp | bool_yes_no}}</p>
        <p class="data-info" *ngIf="user().large_fire_exp === null">--</p>
      </div>
      <div class="data-div">
        <div class="data-title">GACC/Dispatch Unit</div>
        <p class="data-info">{{gaccText}}</p>
      </div>
      <div class="data-div">
        <div class="data-title">IQCS Employee ID</div>
        <p class="data-info">{{user().IQCS_employee_id ?? '--'}}</p>
      </div>
      <div class="data-div">
        <div class="data-title">List other IQCS qualifications on your red card</div>
        <p class="data-info" *ngIf="(user().red_card_qualifications ?? '') != ''">{{user().red_card_qualifications}}</p>
        <p class="data-info" *ngIf="(user().red_card_qualifications ?? '') === ''">--</p>
      </div>
      <div class="data-div">
        <div class="data-title">List BAER Coordinator, Team Lead, or Lead Resource Advisor references</div>
        <p class="data-info" *ngIf="(user().team_references ?? '') != ''">{{user().team_references}}</p>
        <p class="data-info" *ngIf="(user().team_references ?? '') === ''">--</p>
      </div>
      <div class="data-div">
        <div class="data-title">Additional details</div>
        <p class="data-info" *ngIf="(user().skills_add_comments ?? '') != ''">{{user().skills_add_comments}}</p>
        <p class="data-info" *ngIf="(user().skills_add_comments ?? '') === ''">--</p>
      </div>
      <div class="data-div" style="display: flex; flex-wrap: wrap;">
        <div class="data-title" style="width: 100%;">GIS Roles</div>
        <br />
        <p style="width: 50%;">
          NIS-BAER: {{user().NIS_BAER || 'false'}}
        </p>
        <p *ngIf="user().VGIS">
          VGIS: {{user().VGIS || 'false'}}
        </p>
      </div>
    </div>
    <div class="data-div" style="padding-top: 20px; flex:100%;">
      <div class="data-title">Other<div class="data-subtitle">(Other skills and level of experience)</div>
      </div>
      <p class="data-info" *ngIf="(user().skills_text ?? '') != ''">{{user().skills_text}}</p>
      <p class="data-info" *ngIf="(user().skills_text ?? '') === ''">--</p>
    </div>

    <div class="data-column">
      <div class="skill-list">
        <div class="data-title" style="padding-top: 5px;">Resource Advisors Skills/Roles</div>
        <div class="data-title" style="padding-top: 5px;">Experience level <div class="data-subtitle"
            style="flex: 100%; padding-left: 0px;">(# of assignments)</div>
        </div>
        @for (skill of skills_list_advisors; track skill) {
        <div>{{skill.text}}</div>
        <div *ngIf="skill.experience">{{skill.experience}}</div>
        <div *ngIf="!skill.experience">--</div>
        }
      </div>
      <div class="data-div">
        <p class="data-title">Resource Advisor Skills/Roles</p>
        <div class="available-list">
          <mat-chip *ngIf="user().archaeology_heritage_tribal">Archaeology/Heritage/Tribal</mat-chip>
          <mat-chip *ngIf="user().botany_invasives">Botany/Invasives</mat-chip>
          <mat-chip *ngIf="user().lead_read">Lead READ</mat-chip>
          <mat-chip *ngIf="user().roads_engineering">Roads/Engineering</mat-chip>
          <mat-chip *ngIf="user().suppression_repair">Suppression Repair</mat-chip>
          <mat-chip *ngIf="user().timber">Timber</mat-chip>
          <mat-chip *ngIf="user().trails_recreation">Trails/Recreation</mat-chip>
          <mat-chip *ngIf="user().watershed_fisheries_ais">Watershed/Fisheries/AIS</mat-chip>
          <mat-chip *ngIf="user().wilderness">Wilderness</mat-chip>
          <mat-chip *ngIf="user().wildlife">Wildlife</mat-chip>
          <p *ngIf="!user().archaeology_heritage_tribal && 
          !user().botany_invasives &&
          !user().lead_read &&
          !user().roads_engineering &&
          !user().suppression_repair &&
          !user().timber &&
          !user().trails_recreation &&
          !user().watershed_fisheries_ais &&
          !user().wilderness &&
          !user().wildlife">--</p>
        </div>
      </div>
    </div>
    <div class="data-div" style="padding-top: 20px; flex:100%;">
      <div class="data-title">READ Notes <div class="data-subtitle">(Specialty area details)</div>
      </div>
      <p class="data-info" *ngIf="(user().read_text ?? '') != ''">{{user().read_text}}</p>
      <p class="data-info" *ngIf="(user().read_text ?? '') === ''">--</p>
    </div>
  </mat-card-content>
</mat-card>